import { render, staticRenderFns } from "./volumereport_main.vue?vue&type=template&id=22b9dff5&scoped=true"
import script from "./volumereport_main.vue?vue&type=script&lang=js"
export * from "./volumereport_main.vue?vue&type=script&lang=js"
import style0 from "./volumereport_main.vue?vue&type=style&index=0&id=22b9dff5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9dff5",
  null
  
)

export default component.exports